import { useEffect, useState } from "react";
import { viewFileFromS3 } from "../../utils/funtions";
import { useViewAllinformationByid } from "../../adapters/Requests";
import addicon from "../../assets/addicon.svg";
import { useParams } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { User } from "lucide-react";

function ApplicantPhoto({ applicationId: propAppId }) {
  const [previewSrc, setPreviewSrc] = useState(addicon);

  const params = useParams();
  const application_id = propAppId || params.application_id;

  const { data, isLoading, isError } = useViewAllinformationByid({
    application_id,
  });

  useEffect(() => {
    (async function () {
      try {
        if (data?.Applicant?.passport_photo) {
          const signedUrl = await viewFileFromS3(
            data?.Applicant?.passport_photo
          );
          setPreviewSrc(signedUrl);
        }
      } catch (error) {
        console.error("Error fetching file:", error);
      }
    })();
  }, [data?.Applicant?.passport_photo]);

  if (isLoading) {
    return (
      <div className="flex items-center gap-4">
        <Skeleton
          variant="rounded"
          width={80}
          height={80}
          className="rounded-xl"
        />
        <div className="space-y-2">
          <Skeleton variant="text" width={150} height={28} />
          <Skeleton variant="text" width={100} height={20} />
        </div>
      </div>
    );
  }

  if (!data || !data.Applicant) {
    return null;
  }

  return (
    <div className="flex items-center gap-4">
      <div className="flex-shrink-0 w-20 h-20 bg-slate-100 rounded-xl border border-slate-200 overflow-hidden flex items-center justify-center">
        {data.Applicant.passport_photo && previewSrc ? (
          <img
            src={previewSrc}
            alt="Passport"
            className="w-full h-full object-cover"
            onError={() => setPreviewSrc(null)}
          />
        ) : (
          <User className="w-10 h-10 text-slate-300" />
        )}
      </div>
      <div>
        <h2 className="text-xl font-bold text-slate-800 leading-tight">
          {data.Applicant.firstname} {data.Applicant.lastname}
        </h2>
        <p className="text-sm font-medium text-slate-500">Applicant</p>
      </div>
    </div>
  );
}

export default ApplicantPhoto;
